import { createContext, useContext } from 'react';

import Keycloak from 'keycloak-js';
import { identity } from 'lodash';

import type { MFARedirectDestination } from 'containers/UserProfile/mfaUtils';

interface KeycloakInstanceProps {
  keycloak?: Keycloak.KeycloakInstance;
  logOut();
  resetPassword();
  forceRefreshToken();
  // Keep MFA redirects on the same Keycloak instance and realm as sign-in.
  configureTwoFactor(): Promise<void>;
  reauthenticateForMFA(destination?: MFARedirectDestination): Promise<void>;
}

export const KeycloakInstanceContext = createContext<KeycloakInstanceProps>({
  keycloak: undefined,
  logOut: identity,
  resetPassword: identity,
  forceRefreshToken: identity,
  configureTwoFactor: async () => {},
  reauthenticateForMFA: async () => {},
});

export const useKeycloakContext = () => useContext(KeycloakInstanceContext);
